module.exports = {"659005100":"双渠镇","659005101":"丰庆镇","659005102":"海川镇","659005400":"北屯市核心区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659005.json
// module id = 3297
// module chunks = 0